import { AbstractApiClient } from "../AbstractApiClient/AbstractApiClient";
import { getEVerifyClientCompany } from "./routes/getEVerifyClientCompany/getEVerifyClientCompany";
import { postResolveFinalNonConfirmation } from "./routes/postResolveFinalNonConfirmation/postResolveFinalNonConfirmation";
import { postResolvePendingReferral } from "./routes/postResolvePendingReferral/postResolvePendingReferral";
import { postTriggerCaseOnOnboarding } from "./routes/postTriggerCaseOnOnboarding/postTriggerCaseOnOnboarding";

export class WorfClient extends AbstractApiClient {
  public readonly GetEVerifyClientCompany = getEVerifyClientCompany(
    this.Instance
  );
  public readonly PostResolveFinalNonConfirmation =
    postResolveFinalNonConfirmation(this.Instance);
  public readonly PostResolvePendingReferral = postResolvePendingReferral(
    this.Instance
  );
  public readonly PostTriggerEVerifyCaseOnOnboarding =
    postTriggerCaseOnOnboarding(this.Instance);
}
